import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
} from '@mui/material';

const ActionDetailTable = ({ data, headers, renderAction }) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {headers.map((header) => (
              <TableCell key={header.label} sx={{ textAlign: 'center' }}>
                {header.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.length > 0 ? (
            data.map((item, index) => (
              <TableRow key={index}>
                {headers.map((header) => {
                  if (header.field === 'actions') {
                    return (
                      <TableCell key={header.field}>
                        {renderAction(item, index)}
                      </TableCell>
                    );
                  } else {
                    let cellValue =
                      header.field === 'no' ? index + 1 : item[header.field];
                    if (header.formatter) {
                      cellValue = header.formatter(cellValue, item);
                    }
                    return (
                      <TableCell key={header.field} sx={{ textAlign: 'start' }}>
                        {header.tooltip && header.tooltip !== false ? (
                          <Tooltip title={cellValue}>
                            <span>
                              {cellValue && cellValue.length > 25
                                ? `${cellValue.substring(0, 25)}...`
                                : cellValue}
                            </span>
                          </Tooltip>
                        ) : (
                          <span>
                            {cellValue && cellValue.length > 25
                              ? `${cellValue.substring(0, 25)}...`
                              : cellValue}
                          </span>
                        )}
                      </TableCell>
                    );
                  }
                })}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={headers.length} sx={{ textAlign: 'center' }}>
                No Data
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ActionDetailTable;
